import { Component } from '@angular/core';
var SimpleModalComponent = /** @class */ (function () {
    function SimpleModalComponent() {
    }
    /**
     * Initialize dialog with simple HTML content
     * @param {ComponentRef<IModalDialog>} reference
     * @param {Partial<IModalDialogOptions>} options
     */
    SimpleModalComponent.prototype.dialogInit = function (reference, options) {
        if (!options.data) {
            throw new Error("Data information for simple modal dialog is missing");
        }
        this.text = options.data.text;
    };
    SimpleModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'simple-modal-dialog',
                    template: "",
                    styles: [':host { display: block; }'],
                    host: {
                        '[innerHTML]': 'text'
                    }
                },] },
    ];
    return SimpleModalComponent;
}());
export { SimpleModalComponent };
